module.exports = __webpack_public_path__ + "static/thumb6-d4f0c09c0517c228a336797a872856f7.jpg";